<div class="row">
  <div class="col text-end">
    <a [routerLink]="['add']" class="btn btn-primary fw-bold">
      <i class="bi bi-plus-lg me-2"></i>Add Postback
    </a>
  </div>
</div>

<div class="table-responsive">
  <table class="table table-striped table-hover align-middle mt-4">
    <thead>
      <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
        <th tableSorterHeader="id" class="bg-tertiary">ID</th>
        <th class="bg-tertiary">Name</th>
        <th class="bg-tertiary">Goal</th>
        <th class="bg-tertiary">Offers</th>
        <th class="bg-tertiary">Postback URL</th>
        <th class="bg-tertiary">Count</th>
        <th class="bg-tertiary">Private</th>
        <th class="bg-tertiary">Status</th>
        <th class="bg-tertiary text-end">Action</th>
      </tr>
    </thead>
    <tbody>
      @for (postback of postbacks; track postback) {
        <tr>
          <td>{{ postback.id }}</td>
          <td>{{ postback.name }}</td>
          <td>{{ postback.goal }}</td>
          <td>{{ getOffers(postback) }}</td>
          <td>
            <input type="text" class="form-control form-control-sm me-2" [value]="postback.url" readonly>
          </td>
          <td>{{ postback.count }}
            <button class="btn btn-sm" (click)="openPostbackLogModal(postback)"><i
            class="bi bi-clock-history text-warning"></i></button>
          </td>
          <td>
            @if (postback.includePrivate) {
              <i class="bi bi-check-circle-fill text-success"></i>
            }
            @if (!postback.includePrivate) {
              <i class="bi bi-x-circle-fill text-danger"></i>
            }
          </td>
          <td>
            @if (postback.enabled) {
              <i class="bi bi-check-circle-fill text-success"></i>
            }
            @if (!postback.enabled) {
              <i class="bi bi-x-circle-fill text-warning"></i>
            }
          </td>
          <td class="text-end">
            <button *isGranted="['ROLE_API_POSTBACK_LOG_READ', 'ROLE_API_USER_EVENT_READ']"
              (click)="openPostbackModal(postback)" class="btn btn-outline-primary btn-sm me-2">
              <i class="bi bi-eye me-2"></i>View log
            </button>
            <a *isGranted="['ROLE_API_POSTBACK_WRITE']" [routerLink]="[postback.id]"
              class="btn btn-outline-primary btn-sm me-2">
              <i class="bi bi-pencil me-2"></i>Edit
            </a>
            <button (click)="delete(postback)" appConfirm class="btn btn-outline-danger btn-sm">
              <i class="bi bi-trash"></i>
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>

<app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
